import React, { useEffect } from "react";

import { createForm } from "@formily/core";
import { Card, Spin } from "antd";
import "antd/lib/button/style";
import { Table, } from "antd";
import { Button } from 'antd';
import { useState } from "react";
import { useParams } from "react-router-dom";
import en2zh from "../conf/keynames";
import { request, requestkind } from '../unit/request'
import { downloadUploadedFile } from "../unit/download";
import { DownloadOutlined } from '@ant-design/icons'

const form = createForm({
  // validateFirst: true,
});

interface Query {
  AgreementNumber: string,
  Caid: string,
  CreateOrderType: string,
  CustomerName: string,
  PaymentWay: string,
  RegStatus: string
}




const Detail = () => {
  const { type, id } = useParams() as any;
  const [spinning, setSpinning] = useState<boolean>(false)
  const [data, setData] = useState<any>([]);
  const [total, setTotal] = useState(0)
  const [current, setCurrent] = useState(1)


  const get = async () => {
    setSpinning(true)
    let key = ""
    if (type === 'CreditApply') {
      key = 'caid'
    }
    if (type === 'GuaranteeAdd') {
      key = 'daid'
    }
    if (type === 'GuaranteeWithdraw') {
      key = 'deid'
    }
    const k: any = { ...requestkind }
    const kind = k[type]['Detail']
    const p: any = {}
    p[key] = id
    const { Data } = await request({}, p, kind)
    const arr: any[] = []
    let i = 0
    const add = (key: string) => {
      if (Object.prototype.hasOwnProperty.call(Data, key)) {
        if (Data[key]) {
          let v = Data[key]
          if (key === "GuaranteeStartDate" || key === "GuaranteeEndDate") {
            v = v.split(" ")[0]
          }
          if (key === "Amount") {
            v = v.toLocaleString()
          }
          if (key === "FirstYearAmount") {
            if (v === 0 || v === "0") {
              return false
            }
          }
          i++
          arr.push({
            key: i,
            k: en2zh(key),
            v: v
          })
        }
      }
    }
    //第一层 担保申请
    if (type === 'GuaranteeAdd') {
      //第二层 
      console.log("担保申请")
      if (Object.prototype.hasOwnProperty.call(Data, "CreditType")) {
        const value = Data["CreditType"]
        if (value === "Deposit") {
          //保证金
          console.log("保证金")
          add("Daid")
          add("PartnerName")
          add("CreditType")
          add("PartnerType")
          add("Amount")
          add("Comment")
          add("DepositExpiryDate")
          add("RecordFileId")
          add("CreateTime")
          add("CreateUser")
          add("Status")
        }
        if (value === "BankGuarantee") {
          // 银行保函
          console.log("银行保函")
          add("Daid")
          add("PartnerName")
          add("CreditType")

          add("PartnerType")
          add("GuaranteeNumber")
          add("GuaranteeStartDate")
          add("GuaranteeEndDate")

          add("Amount")
          add("Guarantor")

          add("Comment")
          add("RecordFileId")
          add("CreateTime")
          add("CreateUser")
          add("Status")
        }
        if (value === "CorpGuarantee") {
          //公司保函
          add("Daid")
          add("PartnerName")
          add("CreditType")

          add("PartnerType")
          add("GuaranteeNumber")
          add("GuaranteeStartDate")
          add("GuaranteeEndDate")

          add("Amount")
          add("Website")
          add("Guarantor")

          add("Comment")
          add("RecordFileId")
          add("CreateTime")
          add("CreateUser")
          add("Status")
        }
      }
    }
    //第一层 担保提取
    if (type === 'GuaranteeWithdraw') {
      //第二层 
      if (Object.prototype.hasOwnProperty.call(Data, "CreditType")) {
        const value = Data["CreditType"]
        if (value === "Deposit") {
          //保证金
          add("Deid")
          add("PartnerName")
          add("CreditType")
          add("PartnerType")

          add("Amount")
          add("BankAccount")
          add("Guarantor")

          add("Comment")
          add("CreateTime")
          add("CreateUser")
          add("Status")
        }
        if (value === "BankGuarantee") {
          // 银行保函
          add("Deid")
          add("PartnerName")
          add("CreditType")
          add("PartnerType")

          add("GuaranteeNumber")
          add("GuaranteeStartDate")
          add("GuaranteeEndDate")

          add("Amount")
          add("Guarantor")

          add("Comment")
          add("RecordFileId")
          add("CreateTime")
          add("CreateUser")
          add("Status")
        }
        if (value === "CorpGuarantee") {
          //公司保函
          add("Deid")
          add("PartnerName")
          add("CreditType")

          add("PartnerType")
          add("GuaranteeNumber")
          add("GuaranteeStartDate")
          add("GuaranteeEndDate")

          add("Amount")
          add("Website")
          add("Guarantor")

          add("Comment")
          add("RecordFileId")
          add("CreateTime")
          add("CreateUser")
          add("Status")
        }
      }
    }

    if (type === 'CreditApply') {
      if (Object.prototype.hasOwnProperty.call(Data, "CreditType")) {
        const value = Data["CreditType"]

      }

      add("Caid")
      add("PartnerName")
      add("PartnerType")
      add("CustomerName")
      add("CreateOrderType")
      add("ProductType")
      add("AgreementNumber")


      if (!(Data["ProductType"] === "Azure" && Data["CreateOrderType"] === "AdditionalOrder")) {
        add("FirstYearAmount")
      }

      add("TotalAmount")
      add("BillingTerm")
      add("PaymentWay")
      add("Comment")
      add("EptAttachmentID")
      add("CreateTime")
      add("CreateUser")
      add("Status")
    }
    setData(arr)
    setSpinning(false)
  }
  useEffect(() => {
    get()
  }, [])

  const columns = [
    {
      title: "显示项",
      dataIndex: "k",
      key: "k",
      // width:300
    },
    {
      title: "描述",
      dataIndex: "v",
      key: "v",
      render: (text: string | number | boolean) => {
        if (typeof text === "string") {
          if (text.split("-").length === 5) {
            return (
              <Button icon={<DownloadOutlined />} onClick={() => {
                downloadUploadedFile(text)
              }}>下载</Button>
            )
          } else {
            return (
              <span>{en2zh(text)}</span>
            )
          }
        }
        if (typeof text === "number") {
          return (
            <span>{text.toLocaleString()}</span>
          )
        }
        if (typeof text === "boolean") {
          return (
            <span>{text}</span>
          )
        }
      }
    }
  ];
  return (
    <Spin spinning={spinning} tip="获取数据中">
      <Card bordered={false} title="" style={{ width: "100%" }}>
        <Table showHeader={false} bordered={true} columns={columns} dataSource={data} pagination={false} />
      </Card>
    </Spin>
  );
};
export default Detail;
